import { notification } from 'antd'

export const showErrorNotification = error => {
  notification.error({
    message: 'Error',
    duration: null,
    description: error.message || JSON.stringify(error),
  })
}
